import { ROUTES } from './app.routes';
import { provideRouter, withInMemoryScrolling, TitleStrategy } from '@angular/router';
import { LOCALE_ID, ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';

import { provideCloudinaryLoader, registerLocaleData } from '@angular/common';
import { provideHttpClient } from '@angular/common/http';
import localeDeCh from '@angular/common/locales/de-CH';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';

import { provideFirebase } from './shared/firebase/firebase.tokens';
import { SeoTitleStrategy } from './shared/seo/seo-title.strategy';

registerLocaleData(localeDeCh);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZonelessChangeDetection(),
    provideRouter(
      ROUTES,
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'top',
      }),
    ),
    { provide: LOCALE_ID, useValue: 'de-CH' },
    provideHttpClient(),
    provideCloudinaryLoader('https://res.cloudinary.com/lumiron'),
    provideFirebase(),
    provideClientHydration(withEventReplay()),
    { provide: TitleStrategy, useClass: SeoTitleStrategy },
  ],
};
